<template>
  <div v-if="article.length || activity.length || learning_resource.length || circle.length" class="content">
    <template v-if="article.length">
      <div @click="changeTab(1)" class="homtTitle flex flex-align-center">
        <div class="left">学会资讯</div>
        <div class="more flex-1"></div>
        <img src="@/static/images/icon-arrowRight.png" class="arrow">
      </div>
      <div class="newsList">
        <div class="news flex flex-align-center flex-jus-between" v-for="item in article" :key="item.id" @click="$router.push({'name': 'news_details', query: {id: item.id}})">
          <img :src="item.pic" class="img">
          <div class="content flex-1 flex flex-column flex-jus-between">
            <div class="cotent-title no-wrap-2">{{item.title}}</div>
            <div class="content-time">{{item.create_time | formatDate_noS}}</div>
          </div>
        </div>
      </div>
    </template>
  
    <template v-if="activity.length">      
      <div @click="changeTab(2)" class="homtTitle flex flex-align-center">
        <div class="left">学会活动</div>
        <div class="more flex-1"></div>
        <img src="@/static/images/icon-arrowRight.png" class="arrow">
      </div>
      <div class="activityList">
        <div class="activityList-item flex" v-for="item in activity" :key="item.id"  @click="$router.push({ name: 'activityList_details', query: {id: item.id} })">
          <div class="item-img"><img :src="item.pic" alt="" /></div>
          <div class="item-info flex-1 flex flex-column">
            <div class="info-title">{{item.title}}</div>
            <div class="info-time flex flex-align-center">
              <img src="@/static/images/my/time.png" alt="" />
              <div>{{item.startTime}}开始</div>
            </div>
            <div class="info-location flex flex-align-center">
              <img src="@/static/images/my/location.png" alt="" />
              <div>{{item.address}}</div>
            </div>
            <div v-if="item.price*1 == 0" class="info-money">免费</div>
            <div v-else class="info-money">
              <span class="fonS-18">￥{{item.vip_apply_price}}</span>
              <span class="fonS-12 color-00">/起</span>
            </div>
          </div>
          <div v-if="item.quota != -1 && item.join_count>= item.quota" class="item-status item-statusAll">名额已满</div>
          <div class="item-status item-statusAlready">{{item.join_count}}人已报名</div>
          <div v-if="item.end_time*1000 < new Date().getTime()" class="item-status item-statusEnd"></div>
        </div>
      </div>
    </template>


    <template v-if="learning_resource.length">
      <div @click="changeTab(3)" class="homtTitle flex flex-align-center">
        <div class="left">学会资源</div>
        <div class="more flex-1"></div>
        <img src="@/static/images/icon-arrowRight.png" class="arrow">
      </div>
      <div class="flex flex-align-center flex-jus-between flex-wrap">
        <div class="videoItem" v-for="item in learning_resource" :key="item.id">
          <videoItem :width="167" :height="111" :id="item.article_id" :videoSrc="item.video" :content="item.title"></videoItem>
        </div>
      </div>
    </template>


    <template v-if="circle.length">      
      <div @click="changeTab(4)" class="homtTitle flex flex-align-center">
        <div class="left">友圈相关</div>
        <div class="more flex-1"></div>
        <img src="@/static/images/icon-arrowRight.png" class="arrow">
      </div>
      <div class="friendsList">
        <template v-for="item in circle">					
          <div @click="toDetail(item.id)" v-if="item.type == 2" :key="item.id" class="friendsItem flex" >
            <img :src="item.avatar" class="avatar" />
            <div class="right flex-1 flex flex-column">
              <div class="name">{{item.nickname}}</div>
              <div class="time">{{item.time}}</div>
              <div class="content">{{item.brief}}</div>
              <div class="imgList flex flex-align-center flex-jus-between flex-wrap">
                <videoItem :content="''" :width="167" :height="111" :videoSrc="item.content"></videoItem>
              </div>

              <div class="infoStatus flex flex-row-reverse">
                <div class="flex flex-align-center">
                  <img src="@/static/images/my/message.png" class="icon" />
                  <div>{{item.comment_num}}</div>
                </div>

                <div class="flex flex-align-center" style="margin-right: 20px;">
                  <img v-if="item.is_likes == 1" src="../../static/images/index/good_yes.png" class="icon" />
                  <img v-else src="../../static/images/index/good.png" class="icon" />
                  <div>{{item.likes_num}}</div>
                </div>
              </div>
            </div>
          </div>
          <div @click="toDetail(item.id)" v-if="item.type == 1" :key="item.id" class="friendsItem flex">
            <img :src="item.avatar" class="avatar" />
            <div class="right flex-1 flex flex-column">
              <div class="name">{{item.nickname}}</div>
              <div class="time">{{item.time}}</div>
              <div class="content">{{item.brief}}</div>
              <div class="imgList flex flex-align-center flex-jus-between flex-wrap">
                <img v-for="(cItem, cIndex) in item.content" :key="cIndex" :src="cItem" alt="" />
              </div>

              <div class="infoStatus flex flex-row-reverse">
                <div class="flex flex-align-center">
                  <img src="@/static/images/my/message.png" class="icon" />
                  <div>{{item.comment_num}}</div>
                </div>

                <div class="flex flex-align-center" style="margin-right: 20px;">
                  <img v-if="item.is_likes == 1" src="../../static/images/index/good_yes.png" class="icon" />
                  <img v-else src="../../static/images/index/good.png" class="icon" />
                  <div>{{item.likes_num}}</div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>
  </div>
  <div v-else>
    <div class="empty">
			<div class="empty-img">
				<img src="@/static/images/index/emptySearch.png" alt="">
			</div>
			<div class="empty-text">暂无搜索到任何信息</div>
		</div>
  </div>
</template>

<script>
import videoItem from '@/views/components/videoItem.vue';
export default {
  components: {
    videoItem
  },
  props: {
    article: {
      type: Array,
      default: () => {
        return []
      }
    },
    activity: {
      type: Array,
      default: () => {
        return []
      }
    },
    learning_resource: {
      type: Array,
      default: () => {
        return []
      }
    },
    circle: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
    };
  },
  methods: {
    changeTab(index) {
      this.$emit('changeTab', index)
    },
    toDetail(id) {
			this.$router.push({name: 'circleDetail', query: {id}})
		}
  }
}

</script>

<style lang='stylus' scoped>
.content 
  padding 0 30px
.homtTitle
  margin-top 40px
  width 100%
  height 70px
  background-image url('~@/static/images/index/titleBG.png')
  background-size 100px 70px
  background-position left
  background-repeat no-repeat
  .left
    margin-left 25px
    font-size: 36px;
    font-weight: 800;
    color: #151925;
  .more
    text-align right
    font-size: 26px;
    font-weight: 500;
    color: #B1B1B1;
  .arrow
    width 12px
    height 22px
    margin-left 12px
.newsList
  .news
    margin-top 28px
    width 100%
    height 180px
    .img
      width 272px
      height 180px
      border-radius: 10px;
    .content
      height 180px
      margin-left 24px
      .cotent-title
        font-size: 30px;
        font-weight: bold;
        color: #111111;
      .content-time
        font-size: 26px;
        color: #B1B1B1;
.activityList
	padding 30px
	.activityList-item
		background-color #F9F9F9
		border-radius 20px
		margin-bottom 28px
		padding 20px 24px 32px 24px
		position relative
		.item-img
			width 188px
			height 188px
			margin-right 24px
			border-radius 20px
			img
				border-radius 20px
		.item-info
			.info-title
				font-size 30px
				color #000000
			.info-time
				font-size 24px
				color #B1B1B1
				margin-top 18px
				margin-bottom 18px
				img
					width 26px
					height 26px
					margin-right 12px
			.info-location
				font-size 24px
				color #B1B1B1
				margin-bottom 20px
				img
					width 21px
					height 26px
					margin-right 18px
			.info-money
				font-size 30px
				color #DE113C
		.item-status
			position absolute
			bottom 32px
			right 24px
		.item-statusAll
			font-size 24px
			color #9E9E9E
		.item-statusAlready
			font-size 24px
			color #DE113C
		.item-statusEnd
			z-index 10
			width 155px
			height 136px
			background-image url('~@/static/images/index/activityEnd.png')
			background-size 100% 100%
			background-position center
.friendsList
	.friendsItem
		padding-top 44px
		.avatar
			width 84px
			height 84px
			border-radius 50%
		.name
			font-size 28px
			font-weight bold
			color #000000
		.time
			margin-top 8px
			font-size 22px
			color #979797
		.content
			margin-top 24px
			margin-bottom 28px
			width 100%
			font-size 26px
			color #000000
		.imgList
			img
				width 186px
				height 186px
        object-fit cover
				border-radius 20px
				margin-bottom 10px
		.imgList:after
			content ''
			display inline-block
			width 186px
			height 186px
		.right
			margin-left 24px
			border-bottom 2px solid #ECECEC
		.infoStatus
			margin-top 40px
			margin-bottom 40px
			font-size 26px
			color #000000
			.icon
				width 32px
				height 32px
				margin-right 8px
.empty
	background-color inherit
	.empty-img
		margin 280px auto 0 auto
		width 373px
		height 320px
		img
			width 100%
			height 100%
	.empty-text
		width 100%
		text-align center
		margin-top 22px
		font-size: 26px;
		color: #111111;
</style>